export default __webpack_public_path__ + "static/media/mastercard.8af25baf.svg";